var lib_core = require("lib-core");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");

var PolyLineToolView = function (tabView, editorView, model) {
   var self = this;

    this.tabView = tabView;
    this.editorView = editorView;
    this.model = model;

    function highlightActiveMode() {
        if(self.toolButtons) {
            self.toolButtons.forEach(function(button) {
                button.inactive();
            });
            self.toolButtons[self.model.mode()].active();
        }
    }

    this.model.toolOptionsVisible.onChange({}, function (value) {
        if(value) {
            self.toolButtons = self.tabView.showToolOptions(self.getToolOptions());
            highlightActiveMode();
        } else {
            self.tabView.hideToolOptions();
            self.toolButtons = null;
        }
    });
    this.model.mode.onChange({}, function() {
        highlightActiveMode();
    });
};

module.exports = PolyLineToolView;

PolyLineToolView.prototype.getToolOptions = function () {
    var toolOptions = {
        button_1: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: 'Line',
            style: {
                icon: 'icon-polyline-nocorner.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_MODE,
            eventData: {
                mode: cio_datamodel.PolyPointMode.STRAIGHT
            }
        },
        button_2: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: '90-Degree Line',
            style: {
                icon: 'icon-cornertype-right-miter.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_MODE,
            eventData: {
                mode: cio_datamodel.PolyPointMode.CORNER_90
            }
        },
        button_3: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: '90-Degree Arc',
            style: {
                icon: 'icon-cornertype-right-round.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_MODE,
            eventData: {
                mode: cio_datamodel.PolyPointMode.ARC_90
            }
        },
        button_4: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: '180-Degree Arc',
            style: {
                icon: 'icon-polyline-semicircle.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_MODE,
            eventData: {
                mode: cio_datamodel.PolyPointMode.ARC_180
            }
        },
        button_5: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: 'Freeform Arc',
            style: {
                icon: 'icon-polyline-generalarc.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_MODE,
            eventData: {
                mode: cio_datamodel.PolyPointMode.ARC_GENERAL
            }
        },
        button_6: {
            type: ui_extensions.ToolOptionType.BUTTON,
            description: 'Toggle Direction (Space)',
            style: {
                icon: 'icon-polyline-switch-axis.svg'
            },
            eventType: lib_core.GuiEvents.CHANGE_POLYLINE_AXIS
        },
    };

    return toolOptions;
};

